<div mat-dialog-title>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__fadeIn"
    style="position: relative;margin-top: 20px;">
    <div class="close-dialog" mat-dialog-close>
      <span class="material-symbols-outlined">close</span>
    </div>
    @if (set_vencimiento == 0) {
      <h1 class="titulo-simpli">Asigna el tipo de vencimiento </h1>
    }
    @if (set_vencimiento == 2) {
      <h1 class="titulo-simpli">Asignar cantidad de días de vencimiento </h1>
    }
    @if (set_vencimiento == 1) {
      <h1 class="titulo-simpli">Asignar fecha de vencimiento </h1>
    }
  </div>
</div>

<mat-dialog-content>

  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">


    <!--STEPPER CONTROL-->
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-responsive" style="margin-top: 40px;display: none;">

      <div class="container-stepper-simpli">

        <div id="step-simpli1" class="stepper-simpli stepper-simpli-active" (click)="change_step('step-simpli1')">
          <span class="material-symbols-outlined">edit</span>
          <div class="step-text">Vencimiento</div>
        </div>

      </div>

    </div>


    @if (step == 1 && set_vencimiento == 0 ) {
      <div
        class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top animate__animated animate__fadeIn">
        <div style="text-align: center;margin-top: 60px;">
          <mat-label class="l-i">Monto total:</mat-label>
          <mat-label class="l-d" style="position: relative;">$ {{formatMoney(monto_total)}}</mat-label>
        </div>
      </div>
    }

    @if (step == 1 && set_vencimiento == 0) {
      <div
        class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top animate__animated animate__fadeIn">
        <form [formGroup]="valFormFilter" style="margin-top: 30px;">
          <mat-form-field appearance="fill">
            <mat-label>Tipo de vencimiento</mat-label>
            <mat-select formControlName="tipo_vencimiento" (selectionChange)="statuschange($event)">
              <!--fecha de vencimiento, muchas facturas-->
              @if (!single_factura) {
                <mat-option value="1">Asignar misma fecha de vencimiento</mat-option>
              }
              @if (!single_factura) {
                <mat-option value="3">Asignar misma cantidad de días</mat-option>
              }
              @if (!single_factura) {
                <mat-option value="2">Asignar distintas fechas de vencimiento</mat-option>
              }
              @if (!single_factura) {
                <mat-option value="4">Asignar cantidad de días por factura</mat-option>
              }
              <!--opciones de 1 sola factura-->
              @if (single_factura) {
                <mat-option value="6">Asignar fecha de vencimiento</mat-option>
              }
              @if (single_factura) {
                <mat-option value="5">Asignar días de vencimiento</mat-option>
              }
            </mat-select>
            <mat-hint>Selecciona el tipo de vencimiento para tus facturas</mat-hint>
            @if (valFormFilter.controls['tipo_vencimiento'].hasError('required')) {
              <mat-error>
                Este campo es <strong>obligatorio</strong>
              </mat-error>
            }
          </mat-form-field>
          <!--6-->
          @if ((selected == 6 || selected == 1) && single_factura == true || (selected == 6 || selected == 1) && single_factura == false) {
            <mat-form-field appearance="fill" (click)="picker.open()"
              >
              <mat-label>Fecha de vencimiento</mat-label>
              <input type="text" [min]="getMinDateFromEmision()" [max]="getMaxDateFromEmision()" matInput
                [matDatepicker]="picker" (dateChange)="fecha_todas($event)" formControlName="fecha_vencimiento_utc"
                readonly>
              <mat-hint>Asigna la fecha de vencimiento para tus facturas </mat-hint>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              @if (valFormFilter.controls['fecha_vencimiento_utc'].hasError('invalid')) {
                <mat-error>
                  Este campo es <strong>obligatorio</strong>
                </mat-error>
              }
            </mat-form-field>
          }
          <!--5-->
          @if ((selected == 5 || selected == 3) && single_factura == true || (selected == 5 || selected == 3) && single_factura == false) {
            <mat-form-field appearance="fill"
              >
              <mat-label>Cantidad de días</mat-label>
              <input matInput type="number" min="30" max="360" formControlName="dias_vencimiento"
                (keyup)="validate_days($event)" (change)="capturar_fecha_por_dias($event)">
              <mat-hint>Asigna la cantidad de días de vencimiento (entre 30 y 360)</mat-hint>
              @if (valFormFilter.controls['dias_vencimiento'].hasError('min')) {
                <mat-error>
                  El mínimo permitido es <strong>30</strong>.
                </mat-error>
              }
              @if (valFormFilter.controls['dias_vencimiento'].hasError('max')) {
                <mat-error>
                  El máximo permitido es <strong>360</strong>.
                </mat-error>
              }
            </mat-form-field>
          }
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="btn-simpli-container">
                <button [disabled]="loading" class="primary-button" style="margin-right: 0px;" mat-flat-button
                  (click)="submitForm($event, valFormFilter.value)">
                  @if (loading == false) {
                    <span>Continuar</span>
                  }
                  @if (loading == true) {
                    <span><span class="material-symbols-outlined mat-spin">progress_activity</span></span>
                  }
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    }

    @if (set_vencimiento == 1 || set_vencimiento == 2) {
      <div style="display: none;"
        class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top animate__animated animate__fadeIn">
        <div style="text-align: center;">
          @if (set_vencimiento == 1) {
            <h1 class="title-step2">Asigna una fecha para cada factura</h1>
          }
          @if (set_vencimiento == 2) {
            <h1 class="title-step2">Asigna una cantidad de días para cada factura</h1>
          }
          <mat-label class="l-i">Monto total:</mat-label>
          <mat-label class="l-d" style="position: relative;">$ {{formatMoney(monto_total)}}</mat-label>
        </div>
      </div>
    }

    @if (set_vencimiento == 1) {
      <div
        class="col-lg-11 col-md-11 col-sm-11 col-xs-12 col-top animate__animated animate__fadeIn" style="margin: 0 auto;">
        <div class="scroll-container add_factoring">
          @for (i of facturas; track i; let index = $index) {
            <div class="container-facturas">
              <div class=row>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <div class="row divrow">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4"><input class="no-input lab-i" readonly
                    value="N° Factura:"></div>
                    <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8"><input class="no-input lab-d" readonly
                    value="{{i.folio}}"></div>
                  </div>
                  <div class="row divrow">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4"><input class="no-input lab-i" readonly value="Deudor:">
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8"><input class="no-input lab-d" readonly
                    value="{{i.deudor}}"></div>
                  </div>
                  <div class="row divrow">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4"><input class="no-input lab-i" readonly value="Monto:">
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8"><input class="no-input lab-d" readonly
                    value="${{formatMoney(i.monto)}}"></div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" style="text-align: center;margin-top: 5px;">
                  <div class="container-vencimiento l-vencimiento" style="text-align: justify;">Asigna la fecha de
                  vencimiento</div>
                  <div [ngClass]="{'container-vencimiento':true}">
                    <mat-form-field appearance="fill" style="width: 100%;">
                      <mat-label>Fecha de vencimiento</mat-label>
                      <input type="text" readonly matInput [matDatepicker]="picker" [min]="getMinDateForFactura(index)"
                        [max]="getMaxDateForFactura(index)" (dateChange)="fecha_individual($event, index)"
                        #pickerInput{{index}}>
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="btn-simpli-container">
              <button [disabled]="wait_to_send" class="primary-button" mat-flat-button (click)="validate_date()">
                Finalizar
              </button>
            </div>
          </div>
        </div>
      </div>
    }

    @if (set_vencimiento == 2) {
      <div
        class="col-lg-11 col-md-11 col-sm-11 col-xs-12 col-top animate__animated animate__fadeIn"
        style="margin: 0 auto;">
        <div class="scroll-container add_factoring">
          @for (i of facturas; track i; let index = $index) {
            <div class="container-facturas">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <div style="display: flex; align-items: center; margin: 10px 0;">
                    <span style="margin-right: 10px; min-width: 80px;">N° Factura:</span>
                    <span>{{i.folio}}</span>
                  </div>
                  <div style="display: flex; align-items: center; margin: 10px 0;">
                    <span style="margin-right: 10px; min-width: 80px;">Deudor:</span>
                    <span>{{i.deudor}}</span>
                  </div>
                  <div style="display: flex; align-items: center; margin: 10px 0;">
                    <span style="margin-right: 10px; min-width: 80px;">Monto:</span>
                    <span>${{formatMoney(i.monto)}}</span>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" style="text-align: center; margin-top: 5px;">
                  <div style="margin-bottom: 15px;">
                    <label>Asigna la cantidad de días de vencimiento</label>
                  </div>
                  <mat-form-field appearance="fill" style="width: 90%;">
                    <mat-label>Cantidad de días</mat-label>
                    <input matInput min="30" max="360" type="number" (blur)="validate_individual_days($event, index)" (change)="dias_individual($event, index)">
                    <mat-hint>Entre 30 y 360 días</mat-hint>
                  </mat-form-field>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="btn-simpli-container">
              <button [disabled]="wait_to_send" class="primary-button" mat-flat-button
                (click)="validate_date()">
                Continuar
              </button>
            </div>
          </div>
        </div>
      </div>
    }



  </div>

</mat-dialog-content>